import { render, staticRenderFns } from "./downloadFile.vue?vue&type=template&id=782a71d5&scoped=true&"
import script from "./downloadFile.vue?vue&type=script&lang=js&"
export * from "./downloadFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782a71d5",
  null
  
)

export default component.exports